import { render, staticRenderFns } from "./my-account.vue?vue&type=template&id=9decb708&scoped=true"
import script from "./my-account.vue?vue&type=script&lang=js"
export * from "./my-account.vue?vue&type=script&lang=js"
import style0 from "./my-account.vue?vue&type=style&index=0&id=9decb708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9decb708",
  null
  
)

export default component.exports